import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CommonService } from 'src/app/shared/common.service';
import { Router } from '@angular/router';
import { Global } from 'src/app/Global';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import saveAs from 'file-saver';
import { EmployeeRecoveryService } from 'src/app/shared/employee-recovery.service';
import { AlertService } from '../../../common/alert.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-create-recovery-view',
  templateUrl: './create-recovery-view.component.html',
  styleUrls: ['./create-recovery-view.component.css'],
  // standalone:true,
  // imports: [MatDatepickerModule,FormsModule,MatPaginatorModule,
  //   MatTableModule,DropdownModule,ReactiveFormsModule,CommonModule,AutoCompleteModule]
})
export class CreateRecoveryViewComponent implements OnInit {

  /***********************************Declare Private Properties************************/
  EmployeeRecoveryRecordsForm: UntypedFormGroup;
  isLoadingResults = false;
  PenaltyTypeList:any;
  AssestTypeList:any;
  ReportedLocationList:any;
  FirmList:any;
  private alertService: AlertService;
  displayedColumns = ['RecordID', 'EmployeeName', 'EmailID', 'EmployeeLocation', 'ReportedLocation', 'AssetType', 'PenaltyType', 'PenaltyAmount', 'NetRecoveryAmount', 'WaiverID', 'CreatedBy','CreatedDate', 'Status'];

  LocationDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort,{ static: true }) sort: MatSort;
 
  /******************************************END***************************************/

  constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
    public _commonService: CommonService, private error: AppErrorHandler,
    injector: Injector,private status: HTTPStatus,
    private _EmployeeRecovery:EmployeeRecoveryService)
     {this.alertService = injector.get(AlertService); }

  ngOnInit() {
    debugger
    this.paginator.showFirstLastButtons = true;
    this.paginator.pageSize = this._global.RecordSize;

    this.EmployeeRecoveryRecordsForm = this._fb.group({            
      PenaltyTypeID: [''],
      AssetTypeID: [''],
      ReportedLocationID: [''],
      FromRecoveryDate:[],
      ToRecoveryDate:[],
      CreatedBy:[],
      UserLocation:[],
      UserName:[''],
      entityid: [''],   
      PageNumber: (this._global.pageIndex),
      FinanceValue:[''],
      RecoveryID:['']
    });
    this.BindAssetTypeList();
    this.BindPenaltyTypeList();
    this.BindReportedLocationList();   
    this.BindFirmTypeList(); 
    //this.SearchRecord();
  }
  BindPenaltyTypeList() {
    this._commonService.BindDropDown('Penalty').subscribe(result => {
      this.PenaltyTypeList = result;
    });
  }
  BindAssetTypeList() {
    this._commonService.BindDropDown('Assest').subscribe(result => {
      this.AssestTypeList = result;
    });
  }
  BindReportedLocationList() {
    this._commonService.BindDropDown('Location').subscribe(result => {
      this.ReportedLocationList = result;
    });
  }
  BindFirmTypeList() {
    this._commonService.BindDropDown('Firm').subscribe(result => {    
      this.FirmList = result;
    });
  }
  
  SearchRecord() {   
    this._global.pageIndex = 1;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.EmployeeRecoveryRecordsFormList();
  }

  EmployeeRecoveryRecordsFormList() {
    this.status.setHttpStatus(true);
    this.EmployeeRecoveryRecordsForm.controls.PageNumber.setValue(this._global.pageIndex - 1);
    this._EmployeeRecovery.GetAllEmployeeRecoveryList(this.EmployeeRecoveryRecordsForm.value).subscribe(data => {
      if (data.RequestData != null && data.RequestData.length > 0) {    
        debugger   
        this.LocationDataSource = new MatTableDataSource(data.RequestData);
        if (this._global.length === 0) {
          this._global.length = data.TotalRecordCount;
          this.LocationDataSource.paginator = this.paginator;
          this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
          this.LocationDataSource.sort = this.sort;
        } else {
          this.paginator.pageIndex = this._global.pageIndex - 1;
          this.status.setHttpStatus(false);
        }
      } else {
        this.LocationDataSource = new MatTableDataSource(data.RequestData);
        this._global.length = data.TotalRecordCount;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 1;
        this._global.totalPage = 0;
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {  this.status.setHttpStatus(false); });
  }

  ShowDetails(row: any) {     
    this._router.navigate(['admin/create-recovery', row.RequestEntityId]);
  }

  Reset() {
    this.EmployeeRecoveryRecordsForm.reset();
    this.SearchRecord();
  }

  // ******************************************Pagging*************************************//
  onPaginateChange(e: any) {
    this._global.pageIndex = (e.pageIndex + 1);
    this.EmployeeRecoveryRecordsFormList();
  }


  GoToPage() {
    if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
      (this._global.pageIndex > this._global.totalPage) {
      this._global.pageIndex = this._global.totalPage;
    }
    this.EmployeeRecoveryRecordsFormList();
  }


  Export() {
  
    this._EmployeeRecovery.RecoveryExportData(this.EmployeeRecoveryRecordsForm.value).subscribe(x => {
        const blob = new Blob([x], { type: 'application/octet-stream' });
        saveAs(blob, 'EmployeeRecoveryDetails.xls');
    });
  }
  orgValueChange(keyName: String) {
  if (keyName === 'FromDate') {
    if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== '' &&
      this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== null) {
      if (this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.value > this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value) {
        this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.reset();
        this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.reset();
        this.alertService.notify('warn', 'warn!', 'From date cannot be greater than To date.');
      }
    }
  }
  if (keyName === 'ToDate') {
    if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== '' &&
      this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== null) {
      if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value < this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.value) {
        this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.reset();
        this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.reset();
        this.alertService.notify('warn', 'warn!', 'To date cannot be smaller than from date.');
      }
    }
  }
}
  // **************************************Pagging End*************************************//
}
